<template>
  <v-container
    ><SiteHeaderComponent :header="address.name" />
    <div class="text-center grey--text text--darken-2 mb-12">
      <h3>
        <router-link
          :to="{
            name: 'statisticsDistributorArticleTypes',
            params: { lfdnr: lfdnr },
            query: this.$route.query
          }"
          >{{ result.typeName }}
        </router-link>
        >

        <router-link
          :to="{
            name: 'statisticsDistributorArticleCategories',
            params: { lfdnr: lfdnr, articleType: articleType }
          }"
          >{{ result.categoryName }}
        </router-link>

        > Artikel
      </h3>
    </div>
    <div class="d-flex justify-end">
      <v-btn
        class="rounded-pill"
        color="primary"
        :to="{
          name: 'statisticsArticleSearch',
          params: { lfdnr: lfdnr },
          query: this.$route.query
        }"
      >
        <v-icon class="mr-2"> mdi-magnify </v-icon>
        Artikelsuche
      </v-btn>
    </div>
    <div>
      <TimeFilter />
    </div>

    <v-card class="mx-auto mb-12">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suche"
          outlined
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="result.articles"
        :items-per-page="30"
        :search="search"
        item-key="code"
        class="elevation-1 datatable-row-pointer"
        :loading="loading"
        sort-by="description"
        :sort-desc="sortDesc"
        mobile-breakpoint="800"
        @click:row="openArticle"
      >
        <template v-slot:item.image_base64="{ item }">
          <img
            :src="item.image_base64"
            :alt="item.name"
            style="max-height: 70px"
            class="rounded pt-1"
          />
        </template>

        <template v-slot:no-data>
          Keine Artikel in diesem Zeitraum vorhanden.
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

// Services
import addressService from '@/services/crm/addressService.js'
import distributorService from '@/services/statistics/distributorService.js'

// Components
import SiteHeaderComponent from '@/components/core/SiteHeaderComponent.vue'
import TimeFilter from '@/components/statistics/TimeFilter.vue'

export default {
  components: {
    SiteHeaderComponent,
    TimeFilter
  },
  data: () => ({
    address: {
      name: '',
      street: '',
      postcode: '',
      city: '',
      country: '',
      tel: '',
      email: '',
      addressTypes: []
    },
    result: [],
    loading: true,
    search: '',
    sortDesc: false,
    editorContent: '',
    headers: [
      {
        text: 'Bild',
        align: 'start',
        sortable: false,
        value: 'image_base64'
      },
      {
        text: 'Artikel Nr.',
        align: 'start',
        value: 'nr'
      },
      {
        text: 'Bezeichnung',
        align: 'start',
        value: 'description'
      },
      {
        text: 'Anfangsbestand (Stk.)',
        value: 'openingStock',
        align: 'end'
      },
      {
        text: 'Einkäufe (Stk.)',
        value: 'purchases',
        align: 'end'
      },
      {
        text: 'Verkäufe (Stk.)',
        value: 'sales',
        align: 'end'
      },
      {
        text: 'Inventur (Stk.)',
        value: 'inventory',
        align: 'end'
      },
      {
        text: 'Materialverbrauch (Stk.)',
        value: 'materialsInput',
        align: 'end'
      },
      {
        text: 'Endbestand (Stk.)',
        value: 'finalStock',
        align: 'end'
      }
    ]
  }),
  props: {
    lfdnr: {
      type: Number,
      required: true
    },
    articleType: {
      type: String,
      required: true
    },
    category: {
      type: Number,
      required: true
    }
  },
  methods: {
    init() {
      addressService.getAddress(this.lfdnr).then(response => {
        this.address = response.data
      })
      this.loadArticlesStatistics()
    },
    loadArticlesStatistics() {
      this.loading = true
      distributorService
        .getArticlesOfCategoryStatistics(
          this.lfdnr,
          this.articleType,
          this.category,
          this.filterFromDate,
          this.filterToDate
        )
        .then(response => {
          this.result = response.data
          this.loading = false
        })
    },
    openArticle(item) {
      this.$router.push({
        name: 'statisticsArticle',
        params: { lfdnr: this.lfdnr, artNr: item.nr },
        query: this.$route.query
      })
    }
  },
  computed: {
    ...mapState({
      filterFromDate: state => state.statisticsTimeFilter.fromDate,
      filterToDate: state => state.statisticsTimeFilter.toDate
    })
  },
  mounted() {
    this.init()
  },
  watch: {
    filterFromDate: function() {
      this.loadArticlesStatistics()
    },
    filterToDate: function() {
      this.loadArticlesStatistics()
    }
  }
}
</script>

<style scoped>
.datatable-row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
